import React, { Component } from 'react';

import Aux from '../../hoc/Aux';
import Landing from '../../components/Landing/Landing';
// import Modal from '../../components/UI/Modal/Modal';

// const const1 = {
//     _var: 0.7
// };

class Home extends Component {
    state = {
        sample: false
    }

    render () {
        // const disabledInfo = {
        //     ...this.state.ingredients
        // };
    
        // {salad: true, meat: false, ...}
        return (
            <Aux>
                {/* <Modal show={this.state.purchasing} modalClosed={this.purchaseCancelHandler}>
                    <OrderSummary 
                        ingredients={this.state.ingredients}
                        purchaseCancelled={this.purchaseCancelHandler}
                        purchaseContinued={this.purchaseContinueHandler} />
                </Modal> */}
                <Landing />
            </Aux>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/containers/Home/Home.js